import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import StagingPassword from '../../features/auth/components/StagingPassword';

const StagingPasswordRoute: React.FC = () => {
  // Vite env variables are always strings, convert to boolean
  const isStaging = String(import.meta.env.VITE_IS_STAGING).toLowerCase() === 'true';
  const location = useLocation();
  const [isValidated, setIsValidated] = useState(false);

  // Reset validation when pathname changes (user navigated away)
  useEffect(() => {
    if (location.pathname !== '/auth') {
      setIsValidated(false);
    }
  }, [location.pathname]);

  const handleValidationSuccess = useCallback(() => {
    setIsValidated(true);
  }, []);

  // If not staging, bypass password check
  if (!isStaging) {
    return <Outlet />;
  }

  // If password was validated in this component instance, allow access
  // This is in-memory only (no storage) - resets on page refresh or navigation away
  if (isValidated && location.pathname === '/auth') {
    return <Outlet />;
  }

  // Show password page - it will call onValidationSuccess when password is correct
  return <StagingPassword onValidationSuccess={handleValidationSuccess} />;
};

export default StagingPasswordRoute;
